import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import * as StackTrace from 'stacktrace-js';
import { ToastController } from 'ionic-angular';
import { AppConfig } from '../../app/app.config';

@Injectable()
export class FoundationErrorHandler extends ErrorHandler {
  private http: HttpClient;
  config = AppConfig.settings;

  constructor(
    private injector: Injector,
    private toastCtrl: ToastController,
  ) {
    // The true paramter tells Angular to rethrow exceptions, so operations like 'bootstrap' will result in an error
    // when an error happens. If we do not rethrow, bootstrap will always succeed.
    // super(true);
    super();

    this.http = injector.get(HttpClient);
  }

  handleError(error: any): void {
    if (error instanceof HttpErrorResponse) {
      const httpError = error as HttpErrorResponse;
      if (httpError.status === 412 || httpError.status === 401) {
        return;
      } // Don't throw 412 errors or 401 errors as that is handled by auth.interceptor.ts

      error = httpError.error;
    }

    // If error is thrown from Promise.
    if (error.rejection && error.rejection instanceof HttpErrorResponse) {
      const httpError = error.rejection as HttpErrorResponse;
      if (httpError.status === 412 || httpError.status === 401) {
        return;
      } // Don't throw 412 errors or 401 errors as that is handled by auth.interceptor.ts

      error = httpError.error;
    }

    const message = error.message ? error.message : error.toString();

    // suppressing the error that the user gets when switching page after loading a DPR/MoM pdf
    if (error.rejection && (error.rejection.message === 'Cannot read property \'div\' of undefined'
     || error.rejection.message === 'Cannot read properties of undefined (reading \'div\')')) {
      return;
    }

    // suppressing error on login - after having previously used the logout button to logout instead of closing/reloading the browser page
    const stack = error.stack as string;
    if (stack && (stack.includes('TypeError: Cannot read property \'push\' of null\n' +
      '    at NavControllerBase') || stack.includes('Cannot read properties of null (reading \'push\')\n' +
      '    at NavControllerBase'))) {
      return;
    }

    const toast = this.toastCtrl.create({
      message: 'Error Detected - Contact your System Administrator',
      duration: 4000,
      cssClass: 'toast-danger',
      position: 'middle'
    });

    toast.present();

    StackTrace
      .fromError(error)
      .then(stackFrames => {
        const model = this.buildLog(message, stackFrames.map(e => `${e.functionName}() - ${e.fileName}:${e.lineNumber}`));

        this.http.post(`${this.config.apiUrl}/log/error`, model).subscribe();
      }, () => {
        console.warn('StackTrace could not parse error');
      });

    console.error(error);
  }

  private buildLog(message: string, stackTrace: string[]) {
    const error: ErrorEmailModel = {
      time: new Date().toISOString(),
      origin: window.location.origin,
      url: window.location.pathname + window.location.search,
      message: message,
      stackTrace: stackTrace,
      buildNumber: this.config != null ? this.config.version : 'version unknown'
    };

    return error;
  }
}

export interface ErrorEmailModel {
  time: string;
  message: string;
  stackTrace: string[];
  url: string;
  origin: string;
  buildNumber: string;
}



// WEBPACK FOOTER //
// ./src/_foundation/utils/error-handler.ts